import React, { memo } from 'react';

import isEqual from 'lodash/isEqual';

import {
  Grid,
  IconButton,
  Button,
  RemoveCircleOutlineIcon,
} from '@gogame/components';
import {
  FormFieldGroup,
  FormField,
  withArrayFormField,
  useSiblingFieldName,
} from '@gogame/form';

import { loadTargets } from 'scenes/Integrations/sources/postbacks/fields';

import { CONDITIONS, TARGET, ENTITIES } from '../constants';
import { postbackStrategyConditionSchema } from '../schemas';
import FieldEntities from './FieldEntities';

const Conditions = withArrayFormField({
  validationSchema: postbackStrategyConditionSchema,
})(({ value, push, remove, form: { setFieldValue } }) => {
  const getSiblingFieldName = useSiblingFieldName();

  const handleAddStrategy = React.useCallback(() => {
    push(postbackStrategyConditionSchema.default());
  }, [push]);

  const handleChangeTarget = React.useCallback(
    (i) => () => {
      setFieldValue(
        getSiblingFieldName(`${CONDITIONS}.[${i}].${ENTITIES}`),
        []
      );
    },
    [setFieldValue]
  );

  return (
    <React.Fragment>
      {value?.map((strategy, i) => (
        <FormFieldGroup name={`${CONDITIONS}.[${i}]`} key={i}>
          <Grid item xs={5}>
            <FormField.Select
              label={'Targeting'}
              name={TARGET}
              source={loadTargets}
              onChange={handleChangeTarget(i)}
              lazy={true}
              padding={0}
            />
          </Grid>
          <Grid item xs={6}>
            <FieldEntities
              label={'Entities'}
              name={ENTITIES}
              target={strategy[TARGET]}
              padding={0}
            />
          </Grid>
          <Grid container item xs={1} justifyContent={'flex-end'}>
            <IconButton
              icon={<RemoveCircleOutlineIcon />}
              tooltip={'Remove'}
              onClick={() => remove(i)}
            />
          </Grid>
        </FormFieldGroup>
      ))}
      <Grid item xs={12}>
        <Button add color={'primary'} onClick={handleAddStrategy}>
          Condition
        </Button>
      </Grid>
    </React.Fragment>
  );
});

export default memo(Conditions, isEqual);
